import { render, staticRenderFns } from "./RealizarPago.vue?vue&type=template&id=f8c96810&"
import script from "./RealizarPago.vue?vue&type=script&lang=js&"
export * from "./RealizarPago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports